import React from 'react';
import { Form, Input } from 'antd';
import { RuleObject } from 'antd/es/form';

import { useTranslation } from 'react-i18next';

const DEFAULT_REGIONAL_CALENDAR_NAME_MIN_LENGTH = 1;
const DEFAULT_REGIONAL_CALENDAR_NAME_MAX_LENGTH = 80;

const VALID_NAME_REGEXP = /^[A-Za-z\s-]+$/;

const CalendarInputName = (): React.ReactElement => {
  const { t } = useTranslation('Calendar');

  const checkInputValidity = (_: RuleObject, inputValue: string): Promise<void> => {
    const trimmed = inputValue.trim();

    if (
      trimmed.length < DEFAULT_REGIONAL_CALENDAR_NAME_MIN_LENGTH ||
      trimmed.length > DEFAULT_REGIONAL_CALENDAR_NAME_MAX_LENGTH
    ) {
      return Promise.reject(t('createRegionalCalendar.error.nameLength.text'));
    }

    if (!VALID_NAME_REGEXP.test(trimmed)) {
      return Promise.reject(t('createRegionalCalendar.error.invalidCharacters.text'));
    }

    return Promise.resolve();
  };

  return (
    <Form.Item
      name="name"
      rules={[
        { required: true, message: t('createRegionalCalendar.error.required.text') },
        { validator: checkInputValidity },
      ]}
      validateFirst
    >
      <Input data-testid="name-input" allowClear placeholder={t('createRegionalCalendar.form.nameInput.placeholder')} />
    </Form.Item>
  );
};

export { CalendarInputName };
